import React, { useState, useEffect } from 'react'
import { getStringByPropertyName, stringByPropertyNameHasValidValue } from '../Util/Helpers'
import { Above, Below } from '@jetshop/ui/Breakpoints'
import { htmlStringIsValid, shouldShowDescriptionContent } from '../Util/BannerHelpers'
import MobileBanner from './Mobile/MobileBanner'
import DesktopBanner from './Desktop/DesktopBanner'
import BannerSkeleton from '../Skeletons/BannerSkeleton'

const StandardCategoryBanner = ({ category, parents, categorySettings, isSingleBrand }) => {
   const [activeCategory, setActiveCategory] = useState(null)

   useEffect(() => {
      setActiveCategory(category)
   }, [setActiveCategory, category])

   const imageUrl = getStringByPropertyName(
      categorySettings?.properties,
      'image'
   )

   const description = getStringByPropertyName(
      categorySettings?.properties,
      'description'
   )
   const brandLogo = getStringByPropertyName(
      categorySettings?.properties,
      'brandLogo'
   )
   const htmlContent = getStringByPropertyName(
      categorySettings?.properties,
      'customContent'
   )

   const brandBgLogoFade = getStringByPropertyName(
      categorySettings?.properties,
      'brandLogoBackgroundFade'
   )

   const showDescriptionContent = shouldShowDescriptionContent(description, htmlContent)

   const getDescription = (htmlContent, text) => {
      if (htmlStringIsValid(htmlContent)) {
         return (
            <div
               dangerouslySetInnerHTML={{
                  __html: htmlContent,
               }}
            />
         )
      } else if (stringByPropertyNameHasValidValue(text)) {
         return <p>{text}</p>
      }
   }

   const bannerContent = getDescription(htmlContent, description)

   const name = activeCategory?.mainHeader != "" ? activeCategory?.mainHeader : activeCategory?.name;

   if (!activeCategory) {
      return <BannerSkeleton></BannerSkeleton>
   }

   return (
      <>
         <Below breakpoint="xl">
            <MobileBanner
               showDescriptionContent={showDescriptionContent}
               bannerContent={bannerContent}
               activeCategory={activeCategory}
               parents={parents}
               imageUrl={imageUrl}
               name={name}
               // brandLogo={brandLogo}
               // isSingleBrand={undefined}
            />
         </Below>
         <Above breakpoint="xl">
            <DesktopBanner
               showDescriptionContent={showDescriptionContent}
               bannerContent={bannerContent}
               activeCategory={activeCategory}
               parents={parents}
               imageUrl={imageUrl}
               brandLogo={brandLogo}
               isSingleBrand={isSingleBrand}
               brandBgLogoFade={brandBgLogoFade}
               name={name}
            />
         </Above>
      </>
   )
}

export default StandardCategoryBanner